<div>
  <div class="border-b border-gray-100 p-3 md:p-4">
    <div class="flex items-center justify-between w-full">
      <div class="flex items-center space-x-2">
        <mat-icon class="text-indigo-500">graphic_eq</mat-icon>
        <span class="text-xl font-semibold text-gray-800">Audio Analysis</span>
      </div>
      @if (showCloseButton) {
      <button (click)="close()" mat-icon-button class="text-gray-500 hover:text-gray-700 transition-colors">
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
      }
    </div>
  </div>

  <div class="p-3 md:p-4">
    <div class="space-y-4">
      <!-- Accent Analysis -->
      <div class="bg-gray-50 rounded-lg p-3 md:p-4 transition-colors">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <div class="flex items-center justify-center p-2 bg-indigo-100 rounded-lg">
              <mat-icon class="text-indigo-500">record_voice_over</mat-icon>
            </div>
            <div>
              <h3 class="text-sm font-medium text-gray-500">Accent</h3>
              <p class="text-gray-800 mt-1">{{candidate?.resume_analysis?.transcription_analysis?.accent}}</p>
            </div>
          </div>
          <!-- <div class="w-24 text-right">
            <span
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium bg-green-100 text-green-800">
              Excellent
            </span>
          </div> -->
        </div>
      </div>

      <!-- Sentiment Score -->
      <div class="bg-gray-50 rounded-lg p-3 md:p-4 transition-colors">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <div class="flex items-center justify-center p-2 bg-indigo-100 rounded-lg">
              <mat-icon class="text-indigo-500">sentiment_satisfied_alt</mat-icon>
            </div>
            <div>
              <h3 class="text-sm font-medium text-gray-500">Sentiment Polarity</h3>
              <p class="text-gray-800 mt-1">{{candidate?.resume_analysis?.transcription_analysis?.sentiment_polarity}}</p>
            </div>
          </div>
          <div class="w-20">
            <div class="h-2 bg-gray-200 rounded-full overflow-hidden">
              <div class="h-full bg-indigo-500" [style.width.%]="(candidate?.resume_analysis?.transcription_analysis?.sentiment_polarity || 0) * 100"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Duration Analysis -->
      <div class="bg-gray-50 rounded-lg p-3 md:p-4 transition-colors">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <div class="flex items-center justify-center p-2 bg-indigo-100 rounded-lg">
              <mat-icon class="text-indigo-500">timer</mat-icon>
            </div>
            <div>
              <h3 class="text-sm font-medium text-gray-500">Total Word Count</h3>
              <p class="text-gray-800 mt-1">{{candidate?.resume_analysis?.transcription_analysis?.total_word_count}}</p>
            </div>
          </div>
          <!-- <div class="flex items-center space-x-1 text-gray-500">
            <mat-icon>schedule</mat-icon>
            <span class="text-sm">1:34</span>
          </div> -->
        </div>
      </div>

      <!-- Speech Clarity -->
      <div class="bg-gray-50 rounded-lg p-3 md:p-4 transition-colors">
        <div class="flex items-start space-x-3">
          <div class="flex items-center justify-center p-2 bg-indigo-100 rounded-lg">
            <mat-icon class="text-indigo-500">mic</mat-icon>
          </div>
          <div class="flex-1">
            <h3 class="text-sm font-medium text-gray-500">Speech Clarity</h3>
            <p class="text-gray-800 mt-1">{{candidate?.resume_analysis?.transcription_analysis?.speech_clarity}}</p>
            <div class="mt-2 flex space-x-2">
              <span class="px-2 py-1 bg-yellow-100 text-yellow-700 rounded-full text-xs">
                Filler Words: {{candidate?.resume_analysis?.transcription_analysis?.filler_word_count}}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Additional Metrics -->
      <div class="grid grid-cols-2 gap-3">
        <div class="bg-gray-50 rounded-lg p-3 md:p-4 text-center">
          <div class="text-indigo-500 font-semibold break-words">Rating</div>
          <!-- <div class="text-indigo-500 font-semibold break-words">Found</div> -->
          <div class="md:text-2xl font-bold mt-1">{{candidate?.resume_analysis?.transcription_analysis?.rating}}</div>
        </div>
        <div class="bg-gray-50 rounded-lg p-3 md:p-4 text-center">
          <div class="text-indigo-500 font-semibold break-words">Engagement Level</div>
          <div class="md:text-2xl font-bold mt-1">{{candidate?.resume_analysis?.transcription_analysis?.engagement_level}}</div>
        </div>
      </div>

      <div class="space-y-4">
        <div class="flex items-center space-x-2">
          <mat-icon class="text-blue-500">summarize</mat-icon>
          <h3 class="text-lg font-semibold text-gray-700">Rating Justifications</h3>
        </div>

      <div class="space-y-3">
        @for (justification of candidate?.resume_analysis?.transcription_analysis?.justification;track $index)
        {
        <div class="bg-white rounded-lg p-3 md:p-4">
          <div class="flex items-start space-x-3">
            <p class="text-gray-700">{{justification}}</p>
          </div>
        </div>
        }
      </div>
      </div>

      <div class="space-y-4">
        <div class="flex items-center space-x-2">
          <mat-icon class="text-blue-500">summarize</mat-icon>
          <h3 class="text-lg font-semibold text-gray-700">Overall Analysis</h3>
        </div>
        <div class="bg-white rounded-lg p-3 md:p-4">
          <div class="flex items-start space-x-3">
            <p class="text-gray-700"> {{candidate?.resume_analysis?.transcription_analysis?.overall_analysis}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
